export * from '@packdigital/gatsby-theme-ripperoni-message-bus/src/context/MessageBusTopics';

export const NEW_SESSION = 'NEW_SESSION';
export const OPTION_SELECTION = 'OPTION_SELECTION';

export const VIEW_CART = 'VIEW_CART';
export const VIEW_PRODUCT = 'VIEW_PRODUCT';
export const VIEW_COLLECTION = 'VIEW_COLLECTION';
export const INITIAL_LOAD = 'INITIAL_LOAD';
